<template>
  <div :class="$style.footer">
    <div :class="$style.footerB">
      <div :class="$style.left">
        <div :class="$style.leftH">
          <img :class="$style.icon" :src="yywI29" alt="" />
        </div>
        <div :class="$style.leftC">
          专业的游戏交易平台，聚焦游戏帐号与游戏币等周边服务。我们以安全为基、高效为翼，
        </div>
        <div :class="$style.leftC">
          提供全方位服务，让您告别交易烦恼，轻松畅享游戏周边带来的无尽欢乐与精彩！
        </div>
        <div :class="$style.leftB" @click="onClickContactUs">
          <img :class="$style.leftBIcon" :src="yywI30" alt="" />
          <div :class="$style.leftTit">联系我们</div>
        </div>
      </div>
      <div :class="$style.right">
        <div :class="$style.rightT">
          <span :class="$style.copyrightT">
            {{ $t("footer.copyright") }}:
          </span>
          {{ $t("footer.company") }}
        </div>
        <div :class="$style.rightT">{{ $t("footer.address") }}</div>
        <div :class="$style.rightC">
          <a
            :class="$style.rightCA"
            href="https://beian.miit.gov.cn/#/Integrated/index"
            target="_blank"
          >
            {{ $t("footer.icp") }}
          </a>
        </div>
        <div :class="$style.rightB">
          {{ $t("footer.valueAddedServiceLicense") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import yywI29 from "@assets/image/yywI29.png";
import yywI30 from "@assets/image/yywI30.png";

const onClickContactUs = () => {
  window.open("/helpcenter?id=11", '_blank');
};
</script>

<style module>
.footer {
  margin-top: 40px;
  padding: 40px 240px 0;
  height: 300px;
  background-color: #31363d;
}
.footerB {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.left {
}
.leftH {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.leftC {
  font-family: "PingFangSC-regular";
  color: #ffffff;
  font-weight: 400;
  font-size: 18px;
  line-height: 25px;
}
.leftB {
  display: flex;
  align-items: center;
  width: 160px;
  height: 36px;
  border-radius: 18px;
  background-color: #ff942e;
  margin-top: 40px;
  cursor: pointer;
}
.leftBIcon {
  width: 16px;
  height: 15px;
  margin-left: 28px;
  margin-right: 21px;
}
.leftTit {
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
}
.icon {
  width: 140px;
  height: 54px;
}
.right {
  width: 480px;
  height: 120px;
  border-left: 1px solid #cccccc;
  padding-left: 65px;
}
.rightT {
  line-height: 20px;
  margin-bottom: 10px;
  font-family: "PingFangSC-regular";
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
}
.copyrightT {
  margin-right: 10px;
}
.rightC {
  margin-top: 25px;
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
}
.rightCA {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.6);
}
.rightB {
  color: rgba(255, 255, 255, 0.6);
  line-height: 20px;
  font-weight: 400;
  font-size: 14px;
}
</style>